import React, { useState, useEffect } from 'react'
import { connect } from "react-redux"
import TextField from "@material-ui/core/TextField"
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { useHistory } from 'react-router-dom'
import Button from "@material-ui/core/Button"
import DataTable from 'react-data-table-component'
import { CollateralStyles } from '../../CollateralStyles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Input from '@material-ui/core/Input'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Modal from 'antd/es/modal';
import FormControl from '@material-ui/core/FormControl';
import UseForm from '../../../common/UseForm'
import { Container } from '@material-ui/core'
import { customStyleSecondary } from '../../../common/CommonStyles'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'

const Comments = ({ classes, ...props }) => {
    const history = useHistory()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [comment, setComment] = useState()
    const { t } = useTranslation()

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const initialCommentBody = {
        "FormFile": {},
        "WOID": "",
        "BranchOfficeId": "",
        "StageID": "",
        "Comment": ""
    }

    const {
        values,
        handleInpuFileChange
    } = UseForm(initialCommentBody)

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_Comments(props.userLanguage, props.userToken, props.match.params.woid, props.match.params.branchOfficeId, onError, onSuccess)
        return () => {
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmit = e => {
        e.preventDefault()
        if (comment !== undefined) {
            const formData = new FormData()
            formData.append('WOID', props.workDetail[0].woid)
            formData.append('BranchOfficeId', props.match.params.branchOfficeId)
            formData.append('StageID', props.workDetail[0].collateralStageID)
            formData.append('Comment', comment)

            if (values.pdf !== undefined && values.pdf.length !== 0) {
                for (let file of values.pdf) {
                    formData.append("FormFile", file);
                    props.actions.post_Comments(props.userLanguage, props.userToken, formData, onError, onSuccessSave)
                }
            } else {
                props.actions.post_Comments(props.userLanguage, props.userToken, formData, onError, onSuccessSave)
            }
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessSave = (response) => {
        if (response.success) {
            Modal.success({
                title: t('commonMessages.savedSucc')
            })
        } else {
            Modal.error({
                title: t('commonMessages.alert500')
            })
        }
        props.actions.fetch_Comments(props.userLanguage, props.userToken, props.match.params.woid, props.match.params.branchOfficeId, onError, onSuccess)
        setComment("")
        Array.from(document.querySelectorAll("input")).forEach(
            input => (input.value = "")
        )
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`collateralErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    alert(t('commonMessages.alert500'))
                    break
                default:
                    break
            }
        }
    }

    const checkFileType = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['application/pdf', 'image/png', 'image/jpeg']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const onSuccessDelete = (response) => {
        handleCloseBackdrop()
        props.actions.fetch_Comments(props.userLanguage, props.userToken, props.match.params.woid, props.match.params.branchOfficeId, onError, onSuccess)
        if (response.success) {
            Modal.success({
                title: t('commonMessages.deletedSucc')
            })
        } else {
            Modal.error({
                title: 'Error',
                content: response.message
            })
        }
    }

    const handleDelete = (wocid) => {
        handleOpenBackdrop()
        props.actions.delete_Comment(props.userLanguage, props.userToken, wocid, props.match.params.woid, props.match.params.branchOfficeId, onError, onSuccessDelete)
    }

    const columns = [
        {
            name: t('collateralDetails.comments'),
            selector: 'comment',
            width: '682px',
            sortable: true,
            cell: row => row.comment
        },
        {
            name: t('collateralDetails.registerDate'),
            selector: 'creationDate',
            width: '175px',
            sortable: true,
            cell: row => row.creationDate
        },
        {
            name: t('common.user'),
            selector: 'creationUser',
            width: '171px',
            sortable: true,
            cell: row => row.creationUser
        },
        {
            name: "",
            center: true,
            width: '150px',
            cell: row => (buttonForColumns(row))
        }
    ]

    const buttonForColumns = (row) => {
        return (
            <div>
                <Tooltip title={t('common.delete')}>
                    <IconButton style={{ color: '#BF2E2E' }} onClick={() => handleDelete(row.wocid)}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    return (
        <div>
            <Container className={classes.generalBorder}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <br />
                <Grid
                    container
                    direction="row"
                    justify="space-around"
                    alignItems="center"
                    spacing={2}
                >
                    <Grid item xs={12}>
                        <Typography variant="body1" component={'span'}>
                            <Box fontWeight={600}>{t('collateralDetails.uploadComment')}</Box>
                        </Typography>
                        <Typography variant="body1">
                            {t('common.comment')}
                        </Typography>
                        <TextField
                            label=""
                            value={comment}
                            variant="outlined"
                            onChange={e => setComment(e.target.value)}
                            fullWidth={true}
                            multiline
                            rows={3}
                        />
                    </Grid>
                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Typography>{t('commonMessages.addFile')}</Typography>
                            <FormControl fullWidth >
                                <Input
                                    fullWidth
                                    type="file"
                                    name="pdf"
                                    className="filePDF"
                                    onChange={checkFileType}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                            <br />
                            <Button type="button" className={classes.generalBorder} variant="outlined" onClick={handleSubmit}>
                                {t('common.send')}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}></Grid>
                </Grid>
                <Grid>
                    <br />
                    <Typography variant="body1" component={'span'}>
                        <Box fontWeight={600}>{t('collateralDetails.commentsHistory')}</Box>
                    </Typography>
                    <DataTable
                        columns={columns}
                        customStyles={customStyleSecondary}
                        data={props.comments}
                        highlightOnHover
                        defaultSortField="registerDate"
                        dense
                        noHeader
                        responsive
                        striped
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                </Grid>
                <br />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    comments: state.CollateralReducer.comments,
    listByStatus: state.CollateralReducer.listOrders,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

export default connect(mapStateToProps)(withStyles(CollateralStyles)(Comments))